import { RestRequest, RestContext, ResponseFunction } from 'msw'

// it remains to extract type information from msw.
export type MSWRequestHandler = any

export function logMockRequest(handler: MSWRequestHandler): MSWRequestHandler {
  // decorator function that logs mock requests.
  async function handlerWrapper(
    req: RestRequest,
    res: ResponseFunction,
    ctx: RestContext
  ) {
    console.log(
      `Mock handler ${handler.name} is handling ${
        process.server ? 'server' : 'browser'
      }-side request ${req.method} ${req.url}.`
    )
    const response = await handler(req, res, ctx)
    return response
  }
  return handlerWrapper
}

export function requireAuthenticatedUser(
  handler: MSWRequestHandler
): MSWRequestHandler {
  const wrapped = async (
    req: RestRequest,
    res: ResponseFunction,
    ctx: RestContext
  ) => {
    console.dir(req.headers)
    const authHeader = req.headers.get('x-user-token')
    if (!authHeader) {
      console.log('x-user-token header appears to be empty or not present.')
      const responseBody = {
        error_type: 'user_authentication',
        error_code: 'user_auth_token_is_invalid',
        detail: '',
      }
      return res(ctx.status(403), ctx.json(responseBody))
    }
    return handler(req, res, ctx)
  }
  return wrapped
}

export function isUserAuthorized(
  handler: MSWRequestHandler,
  isAuthorized: boolean = true
): MSWRequestHandler {
  const wrapped = async (
    req: RestRequest,
    res: ResponseFunction,
    ctx: RestContext
  ) => {
    if (!isAuthorized) {
      const responseBody = {
        error_type: 'user_authorization',
        error_code: 'client_not_authorized_for_resource',
        detail: '',
      }
      return res(ctx.status(403), ctx.json(responseBody))
    }
    return handler(req, res, ctx)
  }
  return wrapped
}
